/**
 * Creates a JSON Patch document for PATCH requests
 * @param {Object} fieldValues - Object with key-value pairs to update
 * @returns {Array} JSON Patch document array
 */
export function certificationToolCreatePatchDocument(fieldValues) {
  const patchDoc = [];

  Object.keys(fieldValues).forEach(key => {
    patchDoc.push({
      op: 'add',
      path: `/${key}`,
      value: fieldValues[key],
    });
  });

  return patchDoc;
}
